import { Link } from 'react-router-dom';
import {
  Box,
  Typography,
  Container,
  Paper,
  Button,
} from '@mui/material';
import { appDetails } from '../utils/appDetails';

export default function AppsPage() {
  return (
    <Box sx={{ py: 8, minHeight: '100vh', background: '#f9fafb' }}>
      <Container maxWidth="lg">
        <Typography variant="h3" fontWeight={700} mb={6} textAlign="center">
          Our Apps
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 4,
            justifyContent: 'center',
          }}
        >
          {Object.entries(appDetails).map(([slug, app]) => (
            <Paper
              key={slug}
              elevation={3}
              sx={{
                width: 280,
                p: 3,
                borderRadius: 3,
                textAlign: 'center',
                backgroundColor: '#fff',
              }}
            >
              <img
                src={app.imageUrl}
                alt={app.title}
                style={{
                  width: '100%',
                  height: 220,
                  objectFit: 'cover',
                  borderRadius: 8,
                  marginBottom: 16,
                }}
              />
              <Typography variant="h6" fontWeight={600}
              noWrap
              sx={{
                fontSize: 'clamp(0.8rem, 1.2vw, 2rem)', // min 1.2rem, scales with viewport, max 2rem
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}>
                {app.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" mb={2}>
                {app.description}
              </Typography>
              <Button
                component={Link}
                to={`/apps/${slug}`}
                variant="contained"
                fullWidth
                sx={{
                  textTransform: 'none',
                  backgroundColor: '#ff5722',
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: '#e64a19',
                  },
                }}
              >
                View App
              </Button>
            </Paper>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
